import { render } from "./ChurchView.vue?vue&type=template&id=62a92931"
import script from "./ChurchView.vue?vue&type=script&lang=js"
export * from "./ChurchView.vue?vue&type=script&lang=js"

import exportComponent from "D:\\deploy\\ths\\evangelism_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__